import React from 'react';
import ArchitectureLayout from 'components/architecture/ArchitectureLayout';

/**
 * Gateway Architecture Page
 * Documents the API gateway and routing infrastructure
 */
const Gateway = () => {
  const sections = [
    {
      id: 'overview',
      title: 'Gateway Overview',
      content: `Our **Azure API Management (APIM)** gateway serves as the single entry point for all API requests. It provides:

- Unified API access across all services
- Authentication and authorization
- Rate limiting and throttling
- Request/response transformation
- API versioning
- Analytics and monitoring`
    },
    {
      id: 'routing',
      title: 'Request Routing',
      content: `The gateway routes requests to the appropriate backend services:

\`\`\`mermaid
graph LR
    A[Client] --> B[APIM Gateway]
    B --> C{Authentication}
    C -->|Valid| D[Route to Backend]
    C -->|Invalid| E[401 Unauthorized]
    D --> F[Backend API]
    D --> G[Storage]
    D --> H[Other Services]
\`\`\`

Routes are configured based on:
- API path patterns
- HTTP methods
- Authentication requirements
- Backend service endpoints`
    },
    {
      id: 'authentication',
      title: 'Authentication & Authorization',
      content: `The gateway handles authentication using:

- **JWT tokens** from Entra External ID
- **API keys** for public endpoints
- **OAuth 2.0** flows for user authentication
- **Client certificates** for service-to-service communication

All authentication is validated before requests reach backend services.`
    },
    {
      id: 'policies',
      title: 'Gateway Policies',
      content: `We use APIM policies to:

- **Validate JWT tokens** before forwarding requests
- **Rate limit** requests per user/tenant
- **Transform** request/response payloads
- **Add CORS headers** for cross-origin requests
- **Log** all API calls for auditing
- **Cache** responses when appropriate`
    },
    {
      id: 'monitoring',
      title: 'Monitoring & Analytics',
      content: `The gateway provides:

- Real-time API metrics
- Request/response logging
- Error tracking
- Performance monitoring
- Usage analytics per API and user`
    }
  ];

  return (
    <ArchitectureLayout
      title="Gateway"
      lastUpdated="2025-01-15"
      sections={sections}
    />
  );
};

export default Gateway;

